import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import authApiService from "../../../services/authServices";
import { ThreeDots } from 'react-loader-spinner';


const ManageCity = () => {
    const [cityData, setCityData] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const fetchCityData = async () => {
            setLoading(true);

            try {
                const response = await authApiService.get("cityDetails");
                console.log("CityData", response)
                const data = response.data || [];
                setCityData(data);

                if (data.length > 0) {
                    localStorage.setItem("cityId", data[0].id);
                }
            } catch (error) {
                console.error("Error fetching city details:", error);
            } finally {
                setLoading(false); // End loading
            }
        };
        fetchCityData();
    }, []);

   console.log("CityData", cityData)

    const columns = [
        {
            name: "City",
            selector: row => (
                <Link
                    to="/carter/updatecity"
                    state={{ cityId: row.id }}
                    style={{ textDecoration: "none", cursor: "pointer" }}
                >
                    {row.name}
                </Link>
            ),
            sortable: true
        },
        { name: "State", selector: row => row.state, sortable: true },
        { name: "Active", cell: row => <input type="checkbox" checked={row.active} readOnly disabled /> },
    ];

    const customStyles = {
        table: { style: { border: "1px solid #ddd" } },
        headRow: { style: { backgroundColor: "#40444d", color: "#ffffff" } },
        rows: {
            style: {
                "&:nth-of-type(odd)": { backgroundColor: "#dedfdd" },
                "&:nth-of-type(even)": { backgroundColor: "#ffffff" },
            },
        },
    };

    const buttonStyle = {
        background: "#9cb23b",
        padding: "10px 10px",
        margin: "10px 0px",
        border: "none",
        borderRadius: "25px",
        minWidth: "120px",
        color: "#fff",
        cursor: "pointer",
        textAlign: "center",
        marginRight: "20px",
    };

    return (
        <div id="page-admin-users" className="page-admin">
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
                    <ThreeDots
                        height="80"
                        width="80"
                        radius="9"
                        color="#4fa94d"
                        ariaLabel="three-dots-loading"
                        visible={true}
                    />
                </div>
            ) : (
                <DataTable
                    columns={columns}
                    data={cityData}
                    pagination
                    highlightOnHover
                    striped
                    customStyles={customStyles}
                />
            )}
            {/* <Link to="/carter/manageCourses" style={{ ...buttonStyle, textDecoration: "none", display: "inline-block", marginBottom:"50px"}}>
                Manage Courses
            </Link> */}
            <Link to="/carter/registercity" style={{ ...buttonStyle, textDecoration: "none", display: "inline-block", marginBottom: "50px" }}>
                Add New City
            </Link>
        </div>
    );
};

export default ManageCity;
